import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';

@Component({
    selector: 'app-add-company-modal',
    templateUrl: './add-company-modal.component.html',
    styleUrls: ['./add-company-modal.component.scss'],
    standalone: false
})
export class AddCompanyModalComponent implements OnInit {

  companiesList: any = [];
  @Input() type: string;
  searchValue: string;
  subscriptions: Subscription[] = [];
  industrySelectedChips: any[] = [];
  companySizesSelectedChips: any[] = [];
  locationSelectedChips: any[] = [];
  start: number = 0;
  fortuneFilterClick: Boolean = false;
  unicornFilterClick: Boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  companyListLoader: boolean = false;
  totalCompanies: number = 0;

  constructor(private companyInsightsService: CompanyInsightsService, private modalService: NgbModal, private activeModal: NgbActiveModal,
    private localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.fortuneFilterClick = true;
    this.getRecommendCompanies();
    const filterMethodSubscription = this.companyInsightsService.fetchCompanyFilterData.subscribe((res)=> this.getCompanyListData(res))
    this.subscriptions.push(filterMethodSubscription);
  }

  getRecommendCompanies() {
    this.companyListLoader = true;
    let payload = {
      startindex: this.start,
      resultsize: 7,
      searchviaboolean: true,
      booleanquery: this.searchValue ? this.searchValue: '*',
      industries: this.industrySelectedChips.length ? this.industrySelectedChips: [],
      locations: this.locationSelectedChips.length ? this.locationSelectedChips: [],
      companysizes: this.companySizesSelectedChips.length ? this.companySizesSelectedChips:[],
      companybuckettypes: this.fortuneFilterClick == true && this.unicornFilterClick ? ['Fortune500', 'unicorn'] : this.unicornFilterClick == true  && !this.fortuneFilterClick ? ['unicorn']:  !this.unicornFilterClick == true  && this.fortuneFilterClick ? ['fortune500']: null
    }
    this.companyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res.status == "success") {
        this.companyListLoader = false;
        const company = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
        if(this.start > 0) {
          this.companiesList = this.companiesList.concat(company);
         } else {
          this.companiesList = company;
         }
          this.totalCompanies = res.data.totalresultscount;

        }
    })
  }

  clearModal() {
    this.modalService.dismissAll();
  }

  addCompanyForCompare(company) {
      const payload = {
        data: company
      }
      this.passEntry.emit(payload);
    }

  getCompanySearch(event) {
    if(event.type == 'search') {
      this.searchValue = event.searchValue;
      this.industrySelectedChips = [];
      this.companySizesSelectedChips = [];
      this.locationSelectedChips = [];
      this.fortuneFilterClick = false;
      this.unicornFilterClick = false;
      this.start = 0;
    const filterData = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
      fortune: this.searchValue ? false: true,
      unicorn: this.unicornFilterClick,
      search: this.searchValue
    }
  this.companyInsightsService.setCompanyFilterData(filterData);
  this.companiesList = [];
      this.getRecommendCompanies();
    } else if(event.type == 'modal') {
      this.passEntry.emit(event.modalPayload);
    }

  }

  getCompanyListData(response){
    this.industrySelectedChips = response.industry;
    this.companySizesSelectedChips = response.companysize;
    this.locationSelectedChips = response.locations;
    this.fortuneFilterClick = response.fortune;
   this.unicornFilterClick = response.unicorn;

    this.start = 0;
    this.getRecommendCompanies();
  }

  getRecommendation(type) {
    if(type == 'pagination') {
      this.start = this.start + 7;
      this.getRecommendCompanies();
    }
  }

  getDisabledCompareButton(companyId) {
    const companyOneId = this.localStorageService.getItem('companyOneId');
    const companyTwoId = this.localStorageService.getItem('companyTwoId');
    if(companyOneId && companyTwoId)
      return true;
    else if((companyOneId && companyOneId == companyId) && !companyTwoId)
      return true;
    else if(!companyOneId && (companyTwoId && companyTwoId == companyId))
      return true;
    else return false;
  }

    formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

}
